import React from 'react'
import { Alert } from 'react-bootstrap'

import {
  BooleanRadioButtonField, yesNoDataSource, MultiLineField, AnzicFieldMulti, IField, TextRadioButtonField, validateFieldsEx,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import { AustraliaResearchChoices } from '../../../../shared/Utility'
import EMDGAccordion from '../../../../shared/EMDGAccordion'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    visible: boolean
    preview?: boolean
}

export interface State {
    errorMessage?: string
}

export default class SoftwareContainer extends React.Component<Props, State> implements IField {
  isSoftwareCopyright: BooleanRadioButtonField
  describeResearchInAustraliaSoftware: MultiLineField
  softwareRelatesToAustralianResearch: TextRadioButtonField
  anzsicSoftware: AnzicFieldMulti

  constructor(props: Props) {
    super(props)

    this.state = {

    }
  }

  componentDidUpdate(prevProps: Props) {
    const { model, onChange, visible } = this.props

    if (visible
            && (model.isSoftwareCopyright !== prevProps.model.isSoftwareCopyright)) {
      onChange({
        describeResearchInAustraliaSoftware: null,
        softwareRelatesToAustralianResearch: null,
      })
    }

    if (visible
        && (model.softwareRelatesToAustralianResearch === AustraliaResearchChoices.None
            || prevProps.model.softwareRelatesToAustralianResearch === AustraliaResearchChoices.None)
            && model.describeResearchInAustraliaSoftware !== null) {
      onChange({ describeResearchInAustraliaSoftware: null })
    }
    // Check if Q80.b is empty or has spaces
    if (model.describeResearchInAustraliaSoftware === null || model.describeResearchInAustraliaSoftware.match(/^\s*$/)) {
      model.describeResearchInAustraliaSoftware = null
    }
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const { model } = this.props
    if (model.softwareRelatesToAustralianResearch === AustraliaResearchChoices.None || model.isSoftwareCopyright === false) {
        callback && callback(false); // don't ever continue!
        return;
    } 
    validateFieldsEx(
      focus,
      callback,
      this.isSoftwareCopyright,
      this.softwareRelatesToAustralianResearch,
      this.describeResearchInAustraliaSoftware,
    )
  }

  render() {
    const {
      model, onChange, visible, preview,
    } = this.props
    const softwareRelatesToAustralianResearchDataSource = [
      { value: AustraliaResearchChoices.Wholly, label: 'Wholly research or work done in Australia' },
      { value: AustraliaResearchChoices.Substantially, label: 'Substantially research or work done in Australia' },
      { value: AustraliaResearchChoices.None, label: 'None of the above' },
    ]
    const showDescribeResearchInAustraliaSoftware = model.softwareRelatesToAustralianResearch && model.softwareRelatesToAustralianResearch !== AustraliaResearchChoices.None

    return (
      visible && (
        <div style={{ marginTop: '30px' }}>
          { preview && <h4>Software</h4>}
          <EMDGAccordion expanded header="Software">
            <BooleanRadioButtonField
              ref={(r) => { this.isSoftwareCopyright = r }}
              id="isSoftwareCopyright"
              label="80. Is the software a work in which copyright subsists?"
              value={model.isSoftwareCopyright}
              onChange={(isSoftwareCopyright) => onChange({ isSoftwareCopyright })}
              required={visible}
              dataSource={yesNoDataSource}
              preview={preview}
              description={(
                <i>
                  For software to be eligible, it must be of substantially Australian origin. Refer to
                  {' '}
                  <a href="https://www.ipaustralia.gov.au/" target="_blank" rel="noreferrer">IP Australia</a>
                  {' '}
                  for further information on copyright.
                </i>
              )}
            />
            {model.isSoftwareCopyright === false && (
            <Alert className="emdg-page-alerts emdg-page-alerts--error ">
              You are
              {' '}
              <b>not</b>
              {' '}
              eligible to apply for a grant as you do not have eligible software.
            </Alert>
            )}
            {model.isSoftwareCopyright && (
              <>
                <TextRadioButtonField
                  ref={(r) => { this.softwareRelatesToAustralianResearch = r }}
                  id="softwareRelatesToAustralianResearch"
                  label="80.a The software is the result of:"
                  value={model.softwareRelatesToAustralianResearch}
                  onChange={(softwareRelatesToAustralianResearch) => onChange({ softwareRelatesToAustralianResearch })}
                  dataSource={softwareRelatesToAustralianResearchDataSource}
                  block
                  required={model.isSoftwareCopyright}
                  preview={preview}
                />
                {showDescribeResearchInAustraliaSoftware && (
                <MultiLineField
                  ref={(r) => { this.describeResearchInAustraliaSoftware = r }}
                  id="describeResearchInAustraliaSoftware"
                  label="80.b Provide further details to support your answer."
                  value={model.describeResearchInAustraliaSoftware}
                  onChange={(describeResearchInAustraliaSoftware) => onChange({ describeResearchInAustraliaSoftware })}
                  required={showDescribeResearchInAustraliaSoftware}
                  maxLength={1000}
                  preview={preview}
                />
                )}
                {model.softwareRelatesToAustralianResearch === AustraliaResearchChoices.None && (
                <Alert className="emdg-page-alerts emdg-page-alerts--error ">
                  You are
                    {' '}
                  <b>not</b>
                    {' '}
                  eligible to apply for a grant as you do not have eligible software.
                </Alert>
                )}
              </>
            )}
          </EMDGAccordion>
        </div>
      )
    )
  }
}
